window.fit = window.fit || {};

(function($) {

  fit.Modal = function(root) {
    this.element = root;
    var self = this;
    $(window).on('load hashchange', this._open.bind(this));
    this.element.find('.js-modal-close').on('click', this._close.bind(this));

    // Close modal on Escape press
    $(document).on('keydown', function (e) {
        if(e.key === "Escape") {
            self._close();
        }
    });

    // Close modal on overlay
    this._closeOnOutsideClick();
  },

  fit.Modal.prototype = {

    _open : function() {
      if(window.location.hash) {
        var hash = window.location.hash.substring(1);
        if (hash.includes('login') || hash.includes('filebank')) {
          $('.js-modal').each(function() {
            if ($(this).attr('data-modal-id') == hash) {
              $('.js-modal').removeClass('is-open');
              $(this).addClass('is-open');
              $('body').addClass('is-modal-open');
            }
          });
  
          // Build and show overlay
          this._overlay();
        };
      }
    },
    _close : function() {
      history.replaceState(null, null, ' ');
      $('.js-modal').removeClass('is-open');
      $('body').removeClass('is-modal-open');
      $('.js-modal-overlay').removeClass('is-open');
    },
    _closeOnOutsideClick : function () {
      var self = this;
      $('.js-modal').on('click', function(e){
        if (e.target !== this) {
            return;
        }
        self._close();
      });
    },
    _overlay : function() {
      if (!this.overlayModal) {
        var overlay = this.overlayModal = $('<div class="modal__overlay js-modal-overlay">');
        this.element.before(overlay);
      }
      $('.js-modal-overlay').first().addClass('is-open');
    }
  },

  $('.js-modal').each(function() {
      new fit.Modal($(this));
  })

})(jQuery);
